module.exports = __webpack_public_path__ + "img/bg_ pic2.0c2299d5.png";